import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getCookie } from 'libraries/cookie'
import { addFavoriteResponse, favoritesListResponse, GetFavoriteMerchantResponse } from './apiFavoritesSliceTypes'

export const apiFavorites = createApi({
  reducerPath: 'apiFavorites',
  baseQuery: fetchBaseQuery({
    baseUrl: window.config.API_URL,
    prepareHeaders: headers => {
      const storeId = window.config.STORE_ID?.toString() || '';
      if (storeId) {
        headers.set('X-BSTORE-ID', storeId)
      }
      const token = getCookie('token')
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }

      return headers
    },
  }),
  tagTypes: ['Favorites', 'FavoritesCount'],
  endpoints: builder => ({
    getFavorites: builder.query<favoritesListResponse, void>({
      query: () => ({
        url: '/v1/favorite/count',
      }),
      providesTags: ['FavoritesCount'],
    }),
    getFavoriteWithMagazine: builder.query<any, void>({
      query: () => '/v1/favorite/merchant',
    }),
    addFavorite: builder.mutation<addFavoriteResponse, { product_type: string; product_id: number }>({
      query: ({ product_type, product_id }) => ({
        url: `/v1/favorite?product_type=${product_type}&product_id=${product_id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Favorites', 'FavoritesCount'],
    }),
    removeFavorite: builder.mutation<any, { product_type: string; product_id: number }>({
      query: ({ product_type, product_id }) => ({
        url: `/v1/favorite?product_type=${product_type}&product_id=${product_id}`,
        method: 'DELETE',
      }),

      // Only invalidate FavoritesCount to update the counter
      // Don't invalidate 'Favorites' to avoid refetching the list (optimistic updates handle UI)
      invalidatesTags: ['FavoritesCount'],
    }),
    getFavoriteMerchant: builder.query<GetFavoriteMerchantResponse, { merchant_id: number; page?: number }>({
      query: ({ merchant_id, page }) => ({
        url: 'v1/favorite/merchant-items',
        params: {
          merchant_id,
          page,
        },
      }),
      providesTags: ['Favorites'],
    }),
  }),
})

export const { useGetFavoritesQuery, useAddFavoriteMutation, useRemoveFavoriteMutation, useGetFavoriteMerchantQuery } =
  apiFavorites
